module.exports = __webpack_public_path__ + "static/media/gift.8194e7b2.png";